<template>
  <article v-if="$i18n.locale === 'ko'" class="terms-common">
    <p style="margin-bottom: 6px"><span class="terms-title">서비스 이용약관</span></p>
    <pre class="terms-content">
제1조 (목적)
본 약관은 개런터블(이하 "회사")이 운영하는 무브티켓 플랫폼(이하 "플랫폼")에서 제공되는 서비스의 이용 조건 및 절차를 규정하며, 플랫폼 이용자와 회사 간의 권리와 의무를 명확히 하기 위한 것입니다. 회사는 Guarantable Co., Ltd. (한국 법인) 및 Guarantable Pte. Ltd. (싱가포르 법인)를 포함하며, 본 약관에서 공통적으로 적용되는 사항은 "개런터블"로 표현되고, 특정 국가의 정책 및 운영 차이에 따라 Guarantable Co., Ltd. 또는 Guarantable Pte. Ltd.로 별도 표기될 수 있습니다. 회사는 글로벌 고객을 대상으로 플랫폼 서비스를 제공하며, 현지 법인 구조와 정책에 따라 차별화된 서비스를 제공합니다.

제2조 (정의)
1. 플랫폼: 무브티켓 웹사이트 및 애플리케이션으로, 티켓 판매 및 관련 서비스를 제공합니다.
2. 이벤트 주최자: 플랫폼을 통해 티켓을 판매하는 개인, 법인 또는 단체를 의미합니다.
3. 고객: 플랫폼에서 티켓을 구매하거나 서비스를 이용하는 개인 또는 단체를 의미합니다.
4. 이용자: 이 약관에 따라 회사가 제공하는 서비스를 이용하는 자를 의미합니다.
5. 계정: 이용자가 서비스에 접속하기 위해 회사가 승인한 이메일 주소 및 비밀번호의 조합을 의미합니다.
6. 콘텐츠: 이용자가 서비스 이용 중에 업로드, 다운로드, 배포 등을 통해 접근할 수 있는 정보, 문서, 그래픽, 사진 등을 의미합니다.
7. 개런터블: Guarantable Co., Ltd. (한국 법인) 및 Guarantable Pte. Ltd. (싱가포르 법인)를 포함하며, 이벤트 계약 조건에 따라 역할이 분담됩니다.

제3조 (서비스의 제공)
1. 무브티켓 플랫폼의 기본 소유권과 서비스 제공은 개런터블에 의해 이루어집니다.
2. 다만, 특정 국가에서의 서비스는 해당 지역의 (예: 싱가포르 - Guarantable Pte. Ltd.)가 이벤트 주최자와의 계약에 따라 그 역할을 대신할 수 있습니다.
3. 플랫폼을 통해 이루어지는 모든 거래와 서비스 제공은 본 약관 및 해당 국가의 관련 법률에 따라 운영됩니다.
4. 회사는 이용자에게 다음과 같은 서비스를 제공합니다.
 • 공연 및 이벤트 티켓의 발행, 관리 및 검증 서비스
 • 티켓 양도 및 거래 시스템
 • 디지털 및 오프라인 티켓의 위변조 방지 및 검증 서비스
 • 티켓 관리 및 후속 프로모션 서비스
 • 기타 이벤트에 필요한 서비스

제4조 (서비스의 변경 및 중단)
1. 회사는 상당한 이유가 있는 경우, 서비스의 전부 또는 일부를 변경할 수 있습니다.
2. 서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우, 변경사유와 변경내용을 사전에 공지합니다.
3. 회사는 다음에 해당하는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다.
 • 시스템 점검, 유지보수 또는 공사로 인한 경우
 • 정전, 서비스 설비의 장애, 서비스 이용의 폭주 등으로 정상적인 서비스 제공이 어려운 경우
 • 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우

제5조 (결제 및 정산 방식)
1. 한국 내 결제
 • 고객은 Guarantable Co., Ltd.가 제공하는 결제 서비스를 통해 티켓을 구매합니다.
 • Guarantable Co., Ltd.는 고객의 결제금액에서 서비스 수수료를 공제한 후, 잔여 정산 대금을 이벤트 주최자에게 전달합니다.
 • 정산은 국내 결제 서비스의 정산 일정 및 정책에 따라 이루어집니다.
2. 싱가포르 및 기타 국가의 결제
 • 싱가포르 및 기타 국가에서 고객의 결제는 글로벌 결제 시스템(예: Airwallex)을 통해 이루어집니다.
 • 이 경우, Guarantable Pte. Ltd.는 리테일러(Retailer)로서의 역할을 하며, 고객과 플랫폼 간의 직접적인 계약 관계가 형성됩니다.
 • Guarantable Pte. Ltd.는 결제 완료 시 티켓 소유권을 고객에게 이전하며, 이 과정에서 발생한 매출은 전액 매출로 인식됩니다.
 • Guarantable Pte. Ltd.는 고객의 결제 금액 전액을 매출로 산정하며, 서비스 수수료 및 기타 비용은 내부적으로 처리됩니다.

제6조 (환불 및 취소)
1. 환불 및 취소 정책은 이벤트 주최자의 규정에 따릅니다.
2. 회사는 환불 절차를 대행할 수 있으며, 관련 비용은 환불 정책에 따라 적용됩니다.
3. 이용자는 예매 후 일정 기간 내에 취소를 요청할 수 있습니다. 취소 가능 기간과 방법은 각 공연 및 이벤트의 정책 및 국가별 환불 규정에 따릅니다.
4. 취소가 승인된 경우, 회사는 이용자에게 환불 절차를 진행합니다. 환불 금액과 방식은 각 공연 및 이벤트의 정책 및 국가별 규정에 따릅니다. 단, 이용자의 귀책사유로 인한 취소의 경우 환불이 제한될 수 있습니다.

제7조 (티켓 예매 수수료)
1. 회사는 제공하는 예매 서비스에 대해 예매 수수료를 부과할 수 있습니다. 회원 등급 및 예매 방법, 이벤트 유형 등에 따라 차등화된 예매 수수료를 받고 있으며, 예매 수수료 정책은 변경될 수 있습니다.
2. 개별 이벤트 별로 달리 정하지 않는 한, 예매 수수료는 예매 당일 이외에는 환급되지 않습니다.

제8조 (티켓 예매에 대한 취소, 환불)
1. 한국 및 싱가포르 개최 이벤트에 대한 환불 규정 (공통적용)
1.1 예매한 티켓의 취소 처리는 해당 이벤트의 예매 취소 마감 시간 전까지 플랫폼을 통해 가능합니다.
1.2. 판매 및 취소 마감 시간 기준은 플랫폼 이용 안내 또는 이벤트 상세페이지에 명시된 내용에 따릅니다.
1.3. 판매 및 취소 마감 시간은 개별 이벤트별로 다를 수 있으며, 이벤트 주최자에 의해 변경될 수 있습니다.
1.4. 회사는 관련 법률에 따라 예매 후 7일 이내에 취소하는 경우 취소 수수료를 부과하지 아니합니다.
1.5. 1.4항의 기간 이외의 취소 시에는 개별적인 상품에 따라 취소 수수료를 달리 정하고 해당 수수료를 공제할 수 있으며, 취소 수수료 정책은 사전 공지 후 변경될 수 있습니다.
 • 공연/전시 상품의 취소 시점이 공연일로부터 10일 이상 남은 경우:
  - 뮤지컬, 콘서트, 클래식 등 공연권: 취소 티켓 장당 4,000원 (4 SGD)
  - 연극, 전시 등 입장권: 취소 티켓 장당 2,000원 (2 SGD)
 • 공연/전시 상품의 취소 시점이 공연일로부터 10일 이내일 경우:
  - 관람일 9일 전 ~ 관람일 7일 전: 티켓 금액의 10%
  - 관람일 6일 전 ~ 관람일 3일 전: 티켓 금액의 20%
  - 관람일 2일 전 ~ 관람일 1일 전: 티켓 금액의 30%
1.6. 스포츠 상품의 경우: 예매 익일 ~ 취소 마감 시간 전: 티켓 금액의 10% 부과
2. 대만 개최 이벤트에 대한 환불 규정
2.1. 대만 지역에서 판매되는 티켓에 대해서는 이벤트 주최자가 지정한 환불 정책(방안 1~4) 중 하나가 적용됩니다.
2.2. 환불 정책은 이벤트별 상세페이지에 명시되며, 고객은 예매 전에 이를 확인하고 동의해야 합니다.
2.3. 선택 가능한 환불 방안은 다음과 같습니다:
 • 방안 1: 공연 전 10일 이내 환불 불가
  - 공연일 10일 전까지 환불 요청 시, 티켓 금액의 최대 10%를 수수료로 공제 후 환불됩니다.
  - 공연일 10일 이내에는 환불이 불가합니다.
 • 방안 2: 티켓 구매 후 3일 이내 환불 가능
  - 티켓 구매 후 3일 이내 환불 요청 시, 티켓 금액의 최대 5%를 수수료로 공제 후 환불됩니다.
  - 이후에는 환불이 불가합니다.
 • 방안 3: 공연 전 20일 이내 환불 불가
  - 공연일 20일 전까지 환불 요청 시, 티켓 금액의 최대 10%를 수수료로 공제 후 환불됩니다.
  - 공연일 20일 이내에는 환불이 불가합니다.
 • 방안 4: 단계별 환불 수수료 적용
  - 공연일 31일 전까지 환불 요청 시, 티켓 금액의 최대 10%를 수수료로 공제 후 환불됩니다.
  - 공연일 11~30일 전까지 환불 요청 시, 티켓 금액의 최대 30%를 수수료로 공제 후 환불됩니다.
  - 공연일 3~10일 전까지 환불 요청 시, 티켓 금액의 최대 50%를 수수료로 공제 후 환불됩니다.
  - 공연일 2일 전부터는 환불이 불가합니다.
 • 공통 사항
  - 서비스 요금, 발권 수수료, 이체 수수료 및 반송 요금은 환불 대상에서 제외됩니다.

제9조 (고객의 의무)
1. 고객은 플랫폼 이용 시 제공되는 모든 정보를 정확히 입력하고, 결제 및 서비스 이용과 관련한 약관을 준수해야 합니다.
2. 티켓은 명시된 이벤트에 한해 사용 가능하며, 무단으로 양도하거나 재판매할 수 없습니다.
3. 재판매 가능한 티켓의 경우는 이벤트 주최자가 사전에 설정한 조건 내에서 리셀이 가능합니다.
4. 이용자는 서비스 이용 시 다음의 행위를 해서는 안됩니다.
 • 신청 또는 변경 시 허위 내용의 등록
 • 타인의 정보 도용
 • 회사의 지적재산권 등 기타 권리를 침해하는 행위
 • 공공질서 및 미풍양속에 반하는 행위
 • 기타 불법적이거나 부당한 행위

제10조 (계약해지 및 이용제한)
1. 이용자가 서비스 이용 계약을 해지하고자 할 경우, 언제든지 서비스 내의 계정 삭제 기능을 이용하여 해지할 수 있습니다.
2. 회사는 이용자가 본 약관에서 정한 의무를 위반하거나 서비스 운영을 고의로 방해한 경우 사전 통보 후 서비스 이용을 제한하거나 계약을 해지할 수 있습니다.

제11조 (개인정보 보호)
1. 회사는 이용자의 개인정보를 보호하기 위하여 노력하며, 개인정보의 보호 및 사용에 대해서는 관련 법령 및 회사의 개인정보처리방침이 적용됩니다.
2. 회사는 개인정보 보호법에 따라 이용자의 개인정보를 암호화 및 보안 절차를 통해 보호하며, 고객의 동의 없이 제3자에게 제공하지 않습니다.

제12조 (책임 제한)
1. 회사는 이벤트 주최자의 사유로 인한 취소, 일정 변경 등에 대해 책임을 지지 않습니다.
2. 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.
3. 회사는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.
4. 회사는 이용자가 서비스를 통해 기대하는 이익이나 서비스를 이용하면서 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.
5. 회사는 플랫폼 이용과 관련하여 발생한 모든 간접적, 우발적, 특수적 또는 결과적 손해에 대해 책임지지 않습니다.

제13조 (분쟁 해결 및 준거법)
1. 본 약관은 기본적으로 대한민국 법에 따라 해석되고 적용됩니다.
2. 단, 이용자의 거주 국가에 따라 다음과 같은 법률 및 관할 법원이 적용됩니다.
 • 대한민국 고객: 대한민국 법령 적용, 서울중앙지방법원 관할
 • 싱가포르 고객: 싱가포르 법령 적용, Singapore Commercial Court 관할
 • 대만 고객: 중화민국(대만) 법령 적용, Taipei District Court 관할
3. 그 외 국가의 고객은 기본적으로 대한민국 법령에 따르되, 각 국가의 강행법규에 따라 조정될 수 있습니다.

제14조 (약관의 게시와 개정)
1. 회사는 관련 법령을 위반하지 않는 범위 내에서 본 약관을 언제든지 수정할 수 있으며, 수정된 약관은 플랫폼에 게시된 후 즉시 효력을 발휘합니다.
2. 고객은 약관 변경 사항을 숙지할 의무가 있습니다.
3. 회사는 본 약관의 내용을 이용자가 쉽게 알 수 있도록 플랫폼 내에 게시합니다.
4. 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 서비스 초기 화면에 그 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 단, 이용자에게 불리한 변경의 경우에는 적용일자 30일 전부터 공지합니다.

제15조 (문의 및 연락처)
1. Guarantable Co., Ltd. (Republic of Korea)
 • 주소: 서울특별시 송파구 송파대로 201, A-1016
 • 이메일: info@moove.live
2. Guarantable Pte. Ltd. (Singapore, Global)
 • 주소: 8 Marina View #39-04 Asia Square Tower 1 Singapore 018960
 • 이메일: info@moove.live

본 약관은 2025년 4월 1일부터 적용됩니다.
    </pre>
  </article>
  <article v-else-if="$i18n.locale === 'zh-tw'" class="terms-common">
    <p style="margin-bottom: 6px"><span class="terms-title">服務條款</span></p>
    <pre class="terms-content">
[第一條（目的）]
本條款及細則（以下簡稱「本條款」）旨在定義 Guarantable（以下簡稱「本公司」）營運之 MooveTickets 平台（以下簡稱「本平台」）的使用條款及程序。本公司包含 Guarantable Co., Ltd.（大韓民國）及 Guarantable Pte. Ltd.（新加坡）。跨國通用事項稱為「Guarantable」，而特定國家之政策及營運可能指明 Guarantable Co., Ltd. 或 Guarantable Pte. Ltd.。本公司依據各地區之法律及營運需求提供全球服務。

[第二條（定義）]
1. 平台：指提供票券銷售及相關服務之 MooveTickets 網站及應用程式。
2. 活動主辦方：透過本平台銷售票券之個人、法人或組織。
3. 顧客：於本平台購買票券或使用服務之個人或組織。
4. 使用者：根據本條款使用本公司提供服務之任何人。
5. 帳戶：經本公司核准，供使用者存取本平台之電子郵件及密碼組合。
6. 內容：於使用服務期間可存取之資訊、文件、圖形、照片或其他資料。
7. Guarantable：指 Guarantable Co., Ltd.（韓國）及 Guarantable Pte. Ltd.（新加坡），其角色依據活動合約分配。

[第三條（服務提供）]
1. MooveTickets 服務之所有權及提供由 Guarantable 管理。
2. 在特定國家（如新加坡），服務可能由當地實體（如 Guarantable Pte. Ltd.）根據與活動主辦方之合約執行。
3. 本平台上進行之所有交易及服務均受本條款及適用之國家法律規範。
4. 本公司提供以下服務：
• 活動票券之發行、管理及驗證
• 票券轉讓及轉售系統
• 數位及線下票券之防詐欺及驗證
• 票券管理及活動後促銷服務
• 活動營運所需之其他服務

[第四條（服務之修改與暫停）]
1. 本公司得基於正當理由修改部分或全部服務。
2. 服務內容、使用方法或營運時間之變更將事先公告並說明理由。
3. 在下列情況下，本公司得暫時停止服務：
• 系統維護、修理或更新
• 電力中斷或流量過載等技術問題
• 自然災害或國家緊急情況等不可抗力事件

[第五條（付款及結算方式）]
1. 韓國境內之付款
• 顧客透過 Guarantable Co., Ltd. 提供之付款服務購買票券。
• Guarantable Co., Ltd. 從付款金額中扣除服務費，並將剩餘之結算金額轉帳予活動主辦方。
• 結算依當地支付服務提供商之政策及時程處理。
2. 新加坡及其他國家之付款
• 付款透過全球支付系統（如 Airwallex）處理。
• Guarantable Pte. Ltd. 作為零售商，與顧客建立直接合約關係。
• 付款完成後，Guarantable Pte. Ltd. 將票券所有權轉移給顧客，並將全額票券價格視為收入。
• 服務費及其他成本由 Guarantable Pte. Ltd. 內部管理。

[第六條（退款與取消）]
1. 退款與取消政策受活動主辦方之規定管轄。
2. 本公司得代表活動主辦方協助處理退款事宜，並可能收取相關費用。
3. 顧客得在各活動或管轄地區規定之允許期限內申請取消。
4. 退款金額及方式將依活動主辦方之政策辦理。因顧客自身原因取消可能不符合退款條件。

[第七條（票務手續費）]
1. 可能會根據會員等級、訂購方式及活動類型收取訂票手續費。
2. 除非另有規定，訂票手續費於訂購日後不予退還。

[第八條（票券取消及退款費用）]
1. 韓國及新加坡之活動：
1.1. 票券取消必須在適用的取消截止日期前提出。
1.2. 取消費用根據活動剩餘時間收取：
• 活動前 10 天或以上：
- 音樂劇、演唱會、古典音樂表演：每張票 4,000 韓元（約 4 新加坡元）
- 戲劇、展覽：每張票 2,000 韓元（約 2 新加坡元）
• 活動前 9–7 天：票價之 10%
• 活動前 6–3 天：票價之 20%
• 活動前 2–1 天：票價之 30%
1.3. 體育賽事：預訂次日起票價之 10%
2. 台灣之活動：
2.1. 退款政策因活動主辦方選擇之退款方案而異，並於各活動頁面載明。
2.2. 可能之退款方案包括：
• 方案一：活動前 10 天內不予退款；之前取消收取票價之 10% 作為手續費
• 方案二：購買後 3 天內可退款；收取票價之 5% 作為手續費
• 方案三：活動前 20 天內不予退款；之前取消收取票價之 10% 作為手續費
• 方案四：
- 活動前 31 天以上：收取票價之 10% 作為手續費
- 活動前 11–30 天：收取票價之 30% 作為手續費
- 活動前 3–10 天：收取票價之 50% 作為手續費
- 活動前 2 天或更少：不予退款
2.3. 在任何情況下，服務費、發行費、銀行轉帳費及退貨運費均不予退還。

[第九條（顧客義務）]
1. 顧客於使用服務時必須提供正確資訊並遵守本條款。
2. 票券僅得用於指定活動，未經活動主辦方許可不得轉售或轉讓。
3. 僅當活動主辦方預先定義允許之轉售條件時，方可進行轉售。
4. 禁止行為包括：
• 提交不實資訊
• 未經授權使用他人個人資料
• 侵害本公司之智慧財產權
• 從事違反公共秩序或善良風俗之行為
• 其他任何非法或不當行為

[第十條（終止及服務限制）]
1. 使用者可隨時透過帳戶刪除功能終止其帳戶。
2. 本公司得因違反本條款之行為暫停或終止服務。

[第十一條（隱私權政策）]
1. 本公司依據適用之資料保護法律及其隱私權政策保護使用者之個人資訊。
2. 個人資訊可能經過加密、保護，並僅在約定之合約條款範圍內與活動主辦方共享。

[第十二條（責任免除）]
1. 本公司對於因活動主辦方導致之活動取消、日程變更或類似問題不承擔責任。
2. 本公司對於因不可抗力事件導致之服務中斷不承擔責任。
3. 本公司對於因顧客自身原因導致之服務使用障礙不承擔責任。
4. 本公司對於因使用服務取得之資料所致之預期利益損失或損害不承擔責任。
5. 本公司對於因使用本平台所致之間接、附帶、特殊或衍生性損害不承擔責任。

[第十三條（爭議解決及準據法）]
1. 本條款主要受大韓民國法律管轄。
2. 根據提供服務之國家，適用以下準據法及管轄法院：
• 韓國境內之顧客：韓國法律；首爾中央地方法院
• 新加坡境內之顧客：新加坡法律；新加坡商業法院
• 台灣境內之顧客：中華民國（台灣）法律；台北地方法院
3. 其他國家之顧客，應適用韓國法律，但強制性當地法律不在此限。

[第十四條（條款之張貼與修訂）]
1. 本公司得依據適用法律修訂本條款。
2. 修訂後之條款將於張貼於本平台後立即生效。
3. 顧客有責任定期審閱本條款。
4. 本公司應於條款適用前至少 7 天（若對顧客不利則為 30 天）公告修訂內容，包括生效日期及主要變更。

[第十五條（諮詢及聯絡資訊）]
1. Guarantable Co., Ltd.（韓國）
• 地址：101, 14-4, Gwangnaru-ro 17-gil, Gwangjin-gu, Seoul, Republic of Korea
• 電子郵件：info@moove.live
2. Guarantable Pte. Ltd.（新加坡）
• 地址：8 Marina View #39-04 Asia Square Tower 1, Singapore 018960
• 電子郵件：info@moove.live

本條款自 2025 年 4 月 1 日起生效。
    </pre>
  </article>
  <article v-else-if="$i18n.locale === 'ja'" class="terms-common">
    <p style="margin-bottom: 6px"><span class="terms-title">利用規約 (りようきやく)</span></p>
    <pre class="terms-content">
[第1条（目的）]
本規約（以下「本規約」といいます。）は、Guarantable（以下「当社」といいます。）が運営するMooveTicketsプラットフォーム（以下「本プラットフォーム」といいます。）の利用に関する条件及び手続きを定めることを目的とします。当社には、Guarantable Co., Ltd.（大韓民国）及びGuarantable Pte. Ltd.（シンガポール）が含まれます。国を跨いで共通に適用される事項は「Guarantable」と称し、国別のポリシー及び運営においては、Guarantable Co., Ltd.又はGuarantable Pte. Ltd.を特定する場合があります。当社は、各地域の法令及び運営要件に合わせたグローバルサービスを提供します。

[第2条（定義）]
1. プラットフォーム：チケット販売及び関連サービスを提供するMooveTicketsウェブサイト及びアプリケーションを指します。
2. イベント主催者：本プラットフォームを通じてチケットを販売する個人、法人又は団体を指します。
3. 顧客：本プラットフォーム上でチケットを購入し、又はサービスを利用する個人又は団体を指します。
4. ユーザー：本規約に基づき当社が提供するサービスを利用する全ての人を指します。
5. アカウント：ユーザーが本プラットフォームにアクセスするために当社が承認した電子メールとパスワードの組み合わせを指します。
6. コンテンツ：サービス利用中にアクセス可能な情報、文書、グラフィック、写真その他の資料を指します。
7. Guarantable：Guarantable Co., Ltd.（韓国）及びGuarantable Pte. Ltd.（シンガポール）を指し、その役割はイベント契約に基づいて分配されます。

[第3条（サービスの提供）]
1. MooveTicketsサービスの所有権及び提供は、Guarantableによって管理されます。
2. 特定の国（例えば、シンガポール）においては、サービスは、イベント主催者との契約に基づき、それぞれの現地法人（例えば、Guarantable Pte. Ltd.）によって実行される場合があります。
3. 本プラットフォーム上で行われる全ての取引及びサービスは、本規約及び適用される国内法に準拠します。
4. 当社は、以下のサービスを提供します。
• イベントチケットの発行、管理及び認証
• チケットの譲渡及び再販システム
• デジタル及びオフラインチケットの不正防止及び認証
• チケット管理及びイベント後のプロモーションサービス
• イベント運営に必要なその他のサービス

[第4条（サービスの変更及び中断）]
1. 当社は、正当な理由がある場合、サービスの一部又は全部を変更する場合があります。
2. サービス内容、利用方法又は運営時間の変更は、理由を明記の上、事前に告知されます。
3. 当社は、以下の状況において、サービスを一時的に中断する場合があります。
• システム保守、修理又はアップデート
• 電力供給停止又はトラフィック過多等の技術的な問題
• 自然災害又は国家非常事態等の不可抗力事態

[第5条（支払及び決済方法）]
1. 韓国における支払
• 顧客は、Guarantable Co., Ltd.が提供する決済サービスを通じてチケットを購入します。
• Guarantable Co., Ltd.は、支払金額からサービス手数料を差し引き、残りの決済金額をイベント主催者に送金します。
• 決済は、現地の決済サービス提供者のポリシー及びスケジュールに従って処理されます。
2. シンガポール及びその他の国における支払
• 支払は、グローバル決済システム（例えば、Airwallex）を通じて処理されます。
• Guarantable Pte. Ltd.は小売業者として行為し、顧客と直接的な契約関係を締結します。
• 支払完了後、Guarantable Pte. Ltd.はチケットの所有権を顧客に移転し、チケットの全額を収益として認識します。
• サービス手数料その他の費用は、Guarantable Pte. Ltd.によって内部的に管理されます。

[第6条（払戻し及びキャンセル）]
1. 払戻し及びキャンセルポリシーは、イベント主催者の規則に準拠します。
2. 当社は、イベント主催者に代わって払戻し手続きを代行することがあり、関連費用が発生する場合があります。
3. 顧客は、各イベント又は管轄区域が定める許容期間内にキャンセルを申請することができます。
4. 払戻し金額及び方法は、イベント主催者のポリシーに従います。顧客の過失によるキャンセルは、払戻しの対象とならない場合があります。

[第7条（チケット料金）]
1. 会員ティア、予約方法及びイベントの種類に応じて、予約手数料が課金される場合があります。
2. 別途指定がない限り、予約手数料は予約日以降は払戻しできません。

[第8条（チケットのキャンセル及び払戻し手数料）]
1. 韓国及びシンガポールにおけるイベント：
1.1. チケットのキャンセルは、該当するキャンセル期限前までに申請する必要があります。
1.2. キャンセル手数料は、イベントまでの残りの時間に基づいて課金されます。
• イベント10日前以降：
- ミュージカル、コンサート、クラシック公演：1枚あたり4,000韓国ウォン（約4シンガポールドル）
- 演劇、展示会：1枚あたり2,000韓国ウォン（約2シンガポールドル）
• イベント9～7日前：チケット価格の10%
• イベント6～3日前：チケット価格の20%
• イベント2～1日前：チケット価格の30%
1.3. スポーツイベント：予約日の翌日以降、チケット価格の10%
2. 台湾におけるイベント：
2.1. 払戻しポリシーは、イベント主催者が選択した払戻しプランによって異なり、各イベントのページに明記されています。
2.2. 可能な払戻しプランには以下が含まれます。
• プラン1：イベント10日前以降は払戻し不可。それ以前は最大10%のキャンセル料
• プラン2：購入後3日以内は払戻し可能。最大5%のキャンセル料
• プラン3：イベント20日前以降は払戻し不可。それ以前は最大10%のキャンセル料
• プラン4：
- イベント31日前以降：最大10%のキャンセル料
- イベント11～30日前：最大30%のキャンセル料
- イベント3～10日前：最大50%のキャンセル料
- イベント2日前以降：払戻し不可
2.3. いかなる場合でも、サービス料、発券手数料、銀行振込手数料及び返送料は払戻しできません。

[第9条（顧客の義務）]
1. 顧客は、サービス利用中に正確な情報を提供し、本規約を遵守しなければなりません。
2. チケットは、指定されたイベントにのみ使用でき、イベント主催者が許可しない限り、再販又は譲渡することはできません。
3. 再販は、イベント主催者が事前に許可された再販条件を定める場合にのみ許可されます。
4. 禁止事項には以下が含まれます。
• 虚偽の情報を提出すること
• 他の者の個人データを不正に使用すること
• 当社の知的財産権を侵害すること
• 公序良俗に反する行為を行うこと
• その他違法又は不適切な行為

[第10条（契約解除及びサービス制限）]
1. ユーザーは、アカウント削除機能を通じていつでもアカウントを解約することができます。
2. 当社は、本規約の違反があった場合、サービスの停止又は終了を行うことがあります。

[第11条（プライバシーポリシー）]
1. 当社は、適用されるデータ保護法及び当社のプライバシーポリシーに従って、ユーザーの個人情報を保護します。
2. 個人情報は、暗号化され、安全に保護され、合意された契約条件の範囲内でのみイベント主催者と共有されることがあります。

[第12条（免責事項）]
1. 当社は、イベント主催者に起因するイベントのキャンセル、スケジュール変更又は類似の問題について責任を負いません。
2. 当社は、不可抗力事態によるサービスの中断について責任を負いません。
3. 当社は、顧客の行為に起因するサービス利用の中断について責任を負いません。
4. 当社は、サービス利用を通じて取得された資料から生じる期待利益の喪失又は損害について責任を負いません。
5. 当社は、本プラットフォームの利用に関連する間接的、偶発的、特別又は派生的な損害について責任を負いません。

[第13条（紛争解決及び準拠法）]
1. 本規約は、主に大韓民国の法律に準拠します。
2. サービスが提供される国に応じて、以下の準拠法及び管轄裁判所が適用されます。
• 韓国の顧客：韓国法；ソウル中央地方裁判所
• シンガポールの顧客：シンガポール法；シンガポール商業裁判所
• 台湾の顧客：中華民国（台湾）法；台北地方裁判所
3. その他の国の顧客については、強行法規に服することを条件として、韓国法が適用されます。

[第14条（規約の掲示及び改定）]
1. 当社は、適用される法令を遵守し、本規約を改定することがあります。
2. 改定された規約は、本プラットフォームに掲示された時点で直ちに効力を生じます。
3. 顧客は、本規約を定期的に確認する責任があります。
4. 当社は、規約の改定について、適用日の少なくとも7日前（顧客に不利な変更の場合は30日前）までに、効力発生日及び主な変更内容を告知します。

[第15条（問い合わせ先）]
1. Guarantable Co., Ltd.（韓国）
• 住所：101, 14-4, Gwangnaru-ro 17-gil, Gwangjin-gu, Seoul, Republic of Korea
• メールアドレス：info@moove.live
2. Guarantable Pte. Ltd.（シンガポール）
• 住所：8 Marina View #39-04 Asia Square Tower 1, Singapore 018960
• メールアドレス：info@moove.live

本規約は、2025年4月1日から効力を有するものとします。
    </pre>
  </article>
  <article v-else class="terms-common">
    <p style="margin-bottom: 6px"><span class="terms-title">Terms of Service</span></p>
    <pre class="terms-content" >
Article 1 (Purpose)
These Terms & Conditions ("Terms") are established to define the terms and procedures for the use of the MooveTickets platform ("Platform") operated by Guarantable (the "Company"). The Company includes Guarantable Co., Ltd. (Republic of Korea) and Guarantable Pte. Ltd. (Singapore). Matters commonly applied across countries are referred to as "Guarantable," while country-specific policies and operations may specify Guarantable Co., Ltd. or Guarantable Pte. Ltd. The Company provides global services tailored to regional legal and operational requirements.

Article 2 (Definitions)
1. Platform: Refers to the MooveTickets website and application, providing ticket sales and related services.
2. Event Organizer: Individuals, legal entities, or organizations that sell tickets through the Platform.
3. Customer: Individuals or organizations that purchase tickets or use services on the Platform.
4. User: Any person using the services provided by the Company under these Terms.
5. Account: A combination of email and password approved by the Company for User access to the Platform.
6. Content: Information, documents, graphics, photos, or other materials accessible during service use.
7. Guarantable: Refers to Guarantable Co., Ltd. (Korea) and Guarantable Pte. Ltd. (Singapore), with roles distributed based on event contracts.

Article 3 (Service Provision)
1. The ownership and provision of MooveTickets services are managed by Guarantable.
2. In specific countries (e.g., Singapore), services may be carried out by the respective local entity (e.g., Guarantable Pte. Ltd.) under contracts with Event Organizers.
3. All transactions and services conducted on the Platform are governed by these Terms and applicable national laws.
4. The Company provides the following services:
• Issuance, management, and verification of event tickets
• Ticket transfer and resale systems
• Fraud prevention and authentication for digital and offline tickets
• Ticket management and post-event promotional services
• Other services necessary for event operations

Article 4 (Modification and Suspension of Services)
1. The Company may modify part or all of its services for valid reasons.
2. Changes in service content, usage methods, or operating hours will be announced in advance with the reasons stated.
3. The Company may temporarily suspend services under the following circumstances:
• System maintenance, repairs, or updates
• Technical issues such as power outages or traffic overloads
• Force majeure events such as natural disasters or national emergencies

Article 5 (Payment and Settlement Methods)
1. Payments in Korea
 • Customers purchase tickets through the payment services provided by Guarantable Co., Ltd.
 • Guarantable Co., Ltd. deducts service fees from the payment amount and transfers the remaining settlement amount to the Event Organizer.
 • Settlements are processed according to the policies and schedules of local payment service providers.
2. Payments in Singapore and Other Countries
 • Payments are processed through global payment systems (e.g., Airwallex).
 • Guarantable Pte. Ltd. acts as a retailer, forming a direct contractual relationship with customers.
 • Upon payment completion, Guarantable Pte. Ltd. transfers ticket ownership to the customer and recognizes the full ticket price as revenue.
 • Service fees and other costs are internally managed by Guarantable Pte. Ltd.

Article 6 (Refunds and Cancellations)
1. Refund and cancellation policies are governed by the Event Organizer’s rules.
2. The Company may facilitate refund procedures on behalf of Event Organizers, and related costs may apply.
3. Customers may request cancellations within the allowable period specified by each event or jurisdiction.
4. Refund amounts and methods will follow the Event Organizer’s policies. Cancellations due to Customer fault may not qualify for refunds.

Article 7 (Ticketing Fees)
1. Booking fees may be charged according to membership tier, booking method, and event type.
2. Unless otherwise specified, booking fees are non-refundable after the date of booking.

Article 8 (Ticket Cancellation and Refund Fees)
1. For Events in Korea and Singapore:
1.1. Ticket cancellations must be requested before the applicable cancellation deadline.
1.2. Cancellation fees are charged based on the time remaining before the event:
• 10 or more days before event:
- Musicals, concerts, classical performances: 4,000 KRW (approx. 4 SGD) per ticket
- Plays, exhibitions: 2,000 KRW (approx. 2 SGD) per ticket
• 9–7 days before event: 10% of ticket price
• 6–3 days before event: 20% of ticket price
• 2–1 day(s) before event: 30% of ticket price
1.3. Sports events: 10% of ticket price after the day following reservation
2. For Events in Taiwan:
2.1. Refund policies vary depending on the refund plan chosen by the Event Organizer and are specified on each event’s page.
2.2. Possible refund plans include:
• Plan 1: No refunds within 10 days before the event; up to 10% cancellation fee before that
• Plan 2: Refund within 3 days of purchase; up to 5% cancellation fee
• Plan 3: No refunds within 20 days before the event; up to 10% cancellation fee before that
• Plan 4:
- 31+ days before event: up to 10% cancellation fee
- 11–30 days before event: up to 30% cancellation fee
- 3–10 days before event: up to 50% cancellation fee
- 2 days or fewer before event: no refunds
2.3. Service fees, issuing fees, bank transfer fees, and return shipping fees are non-refundable in all cases.

Article 9 (Customer Obligations)
1. Customers must provide accurate information and comply with these Terms during service use.
2. Tickets may only be used for the designated events and cannot be resold or transferred unless permitted by the Event Organizer.
3. Reselling is only allowed when the Event Organizer predefines permissible resale conditions.
4. Prohibited actions include:
• Submitting false information
• Unauthorized use of others' personal data
• Infringing on the Company’s intellectual property rights
• Engaging in activities violating public order or good morals
• Any other illegal or improper conduct

Article 10 (Termination and Service Restrictions)
1. Users may terminate their accounts anytime via the account deletion feature.
2. The Company may suspend or terminate service for violations of these Terms.

Article 11 (Privacy Policy)
1. The Company protects Users’ personal information according to applicable data protection laws and its Privacy Policy.
2. Personal information may be encrypted, secured, and shared with Event Organizers only within agreed contractual terms.

Article 12 (Liability Disclaimer)
1. The Company is not liable for event cancellations, schedule changes, or similar issues caused by Event Organizers.
2. The Company is not responsible for service interruptions due to force majeure events.
3. The Company bears no responsibility for service use disruptions caused by the Customer.
4. The Company is not liable for loss of expected benefits or for damages arising from materials obtained through service use.
5. The Company is not liable for indirect, incidental, special, or consequential damages related to the use of the Platform.

Article 13 (Dispute Resolution and Governing Law)
1. These Terms are principally governed by the laws of the Republic of Korea.
2. Depending on the country where the service is provided, the following governing laws and jurisdictions apply:
• Customers in Korea: Korean law; Seoul Central District Court jurisdiction
• Customers in Singapore: Singaporean law; Singapore Commercial Court jurisdiction
• Customers in Taiwan: Republic of China (Taiwan) law; Taipei District Court jurisdiction
3. For customers in other countries, Korean law shall apply, subject to mandatory local laws.

Article 14 (Posting and Revision of Terms)
1. The Company may revise these Terms in compliance with applicable laws.
2. Revised Terms will become effective immediately upon being posted on the Platform.
3. Customers are responsible for reviewing the Terms regularly.
4. The Company shall announce revisions, including effective dates and key changes, at least 7 days prior to application (or 30 days if unfavorable to Customers).

Article 15 (Inquiries and Contact Information)
1. Guarantable Co., Ltd. (Korea)
 • Address: 101, 14-4, Gwangnaru-ro 17-gil, Gwangjin-gu, Seoul, Republic of Korea
 • Email: info@moove.live
2. Guarantable Pte. Ltd. (Singapore)
 • Address: 8 Marina View #39-04 Asia Square Tower 1, Singapore 018960
 • Email: info@moove.live

These Terms are effective as of April 1, 2025.
    </pre>
  </article>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'MooveTerms'
})
</script>
